import { Card, TextInput } from 'corso-admin-ui';
import DescriptionList, { Description } from '~/components/DescriptionList';
import ProductImage from '~/components/ProductImage';
import { useProductFormContext } from '~/features/products/ProductForm';
import { useProduct } from '~/features/products/ProductProvider';

export function ProductSummary() {
  const product = useProduct();
  const {
    register,
    formState: { errors },
  } = useProductFormContext();
  const isReadOnly = !product.isOffPlatform;

  // a Corso product's handle and id are internal keys with nowhere to look them up
  const descriptions: Description[] = isReadOnly
    ? [
        { term: 'Handle', details: product.handle ?? '—' },
        { term: 'ID', details: product.idFromPlatform },
      ]
    : [];

  return (
    <Card>
      <Card.Line>
        <Card.Heading>Product</Card.Heading>
      </Card.Line>

      <TextInput
        id="product-title"
        label="Title"
        required
        disabled={isReadOnly}
        {...register('title')}
        error={errors.title?.message}
      />

      <div className="flex gap-4">
        <ProductImage
          src={product.imgUrl}
          alt={product.title}
          className="size-24 shrink-0"
        />
        <div className="flex flex-1 flex-col gap-4">
          {descriptions.length > 0 && (
            <DescriptionList descriptions={descriptions} />
          )}
        </div>
      </div>
    </Card>
  );
}
